import { OrderReviewCategory } from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewAnalyticsStore';
import { TrackOrderCategory } from '@porterin/booking-flow/src/track-order/view/stores/TrackOrderAnalyticsStore';
import { FareEstimateCategory } from '@porterin/lead-flow/src/domain/store/FareEstimateStore.store';

export const formatName = (name: string): string => {
  return name.replace(/\+/g, ' ');
};

export const mapScreenToCategory = (screen: string): string => {
  if (screen.endsWith('fare-estimate')) return FareEstimateCategory;
  if (screen.endsWith('order-review')) return OrderReviewCategory;
  if (screen.endsWith('track-order')) return TrackOrderCategory;
  else return '';
};
